import http from './httpService';

export const getCurrentProject = () => {
    return http.get(`${process.env.REACT_APP_MODELIC_API}/viewer/decode`);
};

export const refreshToken = () => {
    return http.get(`${process.env.REACT_APP_MODELIC_API}/auth/refresh`);
};
